export const RESCHEDULE_REASON_MODAL_STAGES = {
  notOpen: 'notOpen',
  reason: 'reason',
  confirm: 'confirm',
  validation: 'validation',
};
